/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ResourceState {
    Operation = 1,
    Maintenance = 2,
    Retired = 3,
    Replace = 4,
}
